import { get } from "lodash";
import intercom from "@irati/utils/intercom";
import sentry from "../../../sentry";
import graphUrl from "../../../graph/utils/getUrl";
import getCodeFromError from "../../helpers/getCodeFromError";
import getDataFromError from "../../helpers/getDataFromError";
import getMessageFromErrorCode from "../../helpers/getMessageFromErrorCode";
import getTraceIdFromError from "../../helpers/getTraceIdFromError";
export default (function (err) {
    sentry.captureException(err);
    var e = err;
    e.errorCode = getCodeFromError(err);
    e.message = getMessageFromErrorCode(e.errorCode, e);
    e.traceId = getTraceIdFromError(err);
    e.errorData = getDataFromError(err, e.traceId, e.errorCode);
    try {
        logErrorToIntercom({
            errorCode: e.errorCode,
            errorData: e.errorData,
            traceId: e.traceId,
            operationName: get(JSON.parse(e.response.config.data), "operationName")
        });
    }
    catch (error) { /* no-op */ }
    throw e;
});
export function getGraphError(res) {
    if (!isGraphError(res)) {
        return res;
    }
    console.log(res);
    var e = new Error();
    e.apiError = get(res, "data.errors.[0].apiError", {});
    e.errorCode = getCodeFromError(res);
    e.message = getMessageFromErrorCode(e.errorCode, e);
    e.traceId = getTraceIdFromError(res);
    e.errorData = getDataFromError(res, e.traceId, e.errorCode);
    e.response = res;
    try {
        logErrorToIntercom({
            errorCode: e.errorCode,
            errorData: e.errorData,
            traceId: e.traceId,
            operationName: get(JSON.parse(e.response.config.data), "operationName")
        });
    }
    catch (error) { /* no-op */ }
    throw e;
}
function isGraphError(res) {
    var url = get(res, "config.url", "");
    var errors = get(res, "data.errors") || [];
    return url === graphUrl() && Array.isArray(errors) && errors.length > 0;
}
function logErrorToIntercom(metadata) {
    return intercom.logError(metadata);
}
